export default {
  signin: {
    title: "Sign In",
    subtitle: "Enter your email and password to sign in",
    email: "Email",
    password: "Password",
    rememberMe: "Remember Me",
    forgotPassword: "Forgot Password?",
    signInButton: "Sign In",
    noAccount: "Don't have an account?",
    signUpLink: "Sign Up",
    or: "Or",
    signInWith: "Sign in with",
    error: "Invalid email or password",
    success: "Signed in successfully",
  },
  signup: {
    title: "Sign Up",
    subtitle: "Create your account to get started",
    name: "Full Name",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    agreeTerms: "I agree to the Terms and Conditions",
    signUpButton: "Sign Up",
    haveAccount: "Already have an account?",
    signInLink: "Sign In",
    or: "Or",
    signUpWith: "Sign up with",
    success: "Account created successfully",
    error: "Failed to create account",
  },
  forgotPassword: {
    title: "Forgot Password",
    subtitle: "Enter your email to reset your password",
    email: "Email",
    resetButton: "Reset Password",
    backToSignIn: "Back to Sign In",
    success: "Password reset email sent",
    error: "Failed to send reset email",
  },
  resetPassword: {
    title: "Reset Password",
    subtitle: "Enter your new password",
    password: "New Password",
    confirmPassword: "Confirm New Password",
    resetButton: "Reset Password",
    success: "Password reset successfully",
    error: "Failed to reset password",
  },
  start: {
    title: "Get Started",
    subtitle: "Enter your email to start with 1Task",
    email: "Enter Your Email To Start with 1Task",
    newOrganization: "New Organization",
    enterDetails: "Enter your new company workspace details",
    agreeTerms: "I agree to the Terms and Conditions",
    getStarted: "Get Started",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign In",
    attentionIsNewCurrency: '"Attention is the new currency"',
    effortlessWriting:
      "The more effortless the writing looks, the more effort the writer actually put into the process.",
    manageYourTasks: "Manage Your",
    fastAndEasyAndSmart: "Fast, Easy and Smart",
    pricing: "Pricing",
  },
};
